import React from 'react'
import { useTranslation } from 'react-i18next'
import SecondaryButton from '../atoms/SecondaryButton'
import PlusSvg from '../other/svg/PlusSvg'
import { MotorbikeStatus } from 'src/redux/motorbikesReducer'

interface VehiclesEmptyStateProps {
  stockTab: MotorbikeStatus
  onAddVehicle: () => void
}

const VehiclesEmptyState = ({ stockTab, onAddVehicle }: VehiclesEmptyStateProps): JSX.Element => {
  const { t } = useTranslation()
  const isSold = stockTab === 'sold'

  return (
    <div className="self-stretch flex-1 p-6 flex flex-col justify-center items-center gap-6 overflow-hidden">
      <div className="flex flex-col justify-center items-center gap-3">
        {isSold && (
          <div className="inline-flex justify-start items-center gap-2.5">
            <img
              className="w-[216px] h-[167px] rounded-lg border border-borders-border-base object-cover"
              src="/assets/images/vehicles-sold-empty.png"
              alt=""
            />
          </div>
        )}
        <div className="inline-flex flex-col justify-center items-center gap-1 max-w-lg">
          <div
            className={`text-center justify-start text-foregrounds-fg-base text-xl font-semibold font-Montserrat ${
              isSold ? 'leading-6' : 'leading-5'
            }`}>
            {t(isSold ? 'my_vehicles.sold_empty_title' : 'my_vehicles.empty_title')}
          </div>
          <div className="text-center justify-start text-foregrounds-fg-subtle text-sm font-medium font-Montserrat leading-5">
            {t(isSold ? 'my_vehicles.sold_empty_subtitle' : 'my_vehicles.empty_subtitle')}
          </div>
        </div>
      </div>
      {!isSold && (
        <div className="pb-2 inline-flex justify-center items-center gap-6">
          <SecondaryButton onClick={onAddVehicle} icon={<PlusSvg className="w-3.5 h-3.5 text-icon-secondary" />}>
            {t('my_vehicles.add_vehicle')}
          </SecondaryButton>
        </div>
      )}
    </div>
  )
}

export default VehiclesEmptyState
